/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React from 'react';
import PropTypes from "prop-types";
import { useView } from 'react-view';
import { GuideSectionPropsDescription } from './guide_section_props_description';

// @ts-ignore not TS
import Knobs from '../../../services/playground/knobs';
// @ts-ignore not TS
import { propUtilityForPlayground } from '../../../services/playground';
export var GuideSectionPropsTable = function GuideSectionPropsTable(_ref) {
  var componentName = _ref.componentName,
    component = _ref.component;
  var docgenInfo = Array.isArray(component.__docgenInfo) ? component.__docgenInfo[0] : component.__docgenInfo;
  var props = docgenInfo.props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GuideSectionPropsDescription, {
    componentName: componentName,
    component: component
  }), /*#__PURE__*/React.createElement(PlaygroundProps, {
    isPlayground: false,
    config: {
      componentName: componentName,
      props: propUtilityForPlayground(props),
      scope: component
    }
  }));
};
GuideSectionPropsTable.propTypes = {
  componentName: PropTypes.any.isRequired,
  component: PropTypes.any.isRequired
};
var PlaygroundProps = ({
  config,
  isPlayground
}) => {
  const params = useView(config);
  return <Knobs {...params.knobProps} isPlayground={isPlayground} />;
};
try {
  GuideSectionPropsTable.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3672379046/src/src-docs/src/components/guide_section/guide_section_parts/guide_section_props_table.tsx',
    description: '',
    displayName: 'GuideSectionPropsTable',
    methods: [],
    props: {
      componentName: {
        defaultValue: null,
        description: '',
        name: 'componentName',
        parent: undefined,
        declarations: [{
          fileName: 'src/src-docs/src/components/guide_section/guide_section_parts/guide_section_props_table.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'any'
        }
      },
      component: {
        defaultValue: null,
        description: '',
        name: 'component',
        parent: undefined,
        declarations: [{
          fileName: 'src/src-docs/src/components/guide_section/guide_section_parts/guide_section_props_table.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'any'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}